// extracted by mini-css-extract-plugin
export var leftAlign = "_2p-2";
export var popper = "_2p-0";
export var subtitle = "_2p-1";